import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import Main from './main';
import Login from './login';
import Editor from './editor';
import DomainsParser from './domainsParser';
import DomainsChecker from './domainsChecker';
import AutoPurchase from './autoPurchase';
import AutoPoster from './autoPoster';
import SearchDomain from './searchDomain';
import PingPage from './pingPage';
import IndexChecker from './indexChecker';
import PrivateRoute from '../helpers/privateRoute';
import TemplateGenerator from './templateGenerator';
import ChangeIp from './changeIp';

const App = () => {
	return (
		<Router>
			<Switch>
				<Route path="/login" component={Login} />
				<PrivateRoute exact path="/" component={Main} />
				<PrivateRoute path="/editor" component={Editor} />
				<PrivateRoute path="/domains-parser" component={DomainsParser} />
				<PrivateRoute path="/domains-checker" component={DomainsChecker} />
				<PrivateRoute path="/auto-purchase" component={AutoPurchase} />
				<PrivateRoute path="/auto-poster" component={AutoPoster} />
				<PrivateRoute path="/search-domain" component={SearchDomain} />
				<PrivateRoute path="/ping" component={PingPage} />
				<PrivateRoute path="/index-checker" component={IndexChecker} />
				<PrivateRoute path="/template-generator" component={TemplateGenerator} />
				<PrivateRoute path="/change-ip" component={ChangeIp} />
			</Switch>
		</Router>
	);
};

export default App;
